<!--
 * @LastEditors: Yx
 * @LastEditTime: 2022-07-21 14:16:49
 * @Description: 
 * @Author: Yx
 * @Date: 2022-07-15 17:04:50
 * @FilePath: \szjzsoft-framework\src\views\trend\detail.vue
-->
<template>
    <div class="trend-detail">
      <div class="banner">
        <img src="~imgs/trend/detail-banner.jpg" alt="">
      </div>
      <!-- <div class="container">
        <div class="breadcrumb">
          首页>>金政动态
        </div>
        <div class="content">
          <div class="title">
            {{data.title}}
          </div>
          <div class="txt" v-html="data.content">

          </div>
          <div class="time">
            <span>发布时间：</span><span>{{data.releaseTime}}</span>
          </div>
        </div>
      </div> -->
    </div>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      data: ""
    };
  },
  created() {}
};
</script>

<style lang="scss">
/* *                         { padding:0; margin:0; }*/
.trend-detail .container .txt {
  img {
    max-width: 100%;
    display: block;
    width: auto;
  }
  a {
    text-decoration: none;
  }
  iframe {
    width: 100%;
  }
  p {
    line-height: 1.6;
    margin: 0px;
  }
  table {
    word-wrap: break-word;
    word-break: break-all;
    max-width: 100%;
    border: 1px solid #999;
  }
  tbody,
  th,
  td,
  tr {
    border: inherit;
  }
  .mce-object-iframe {
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  ul,
  ol {
    list-style-position: inside;
  }
}
</style>
